// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31fBR","controls":"styles_controls__SI-xO","charLimit":"styles_charLimit__1neVU","input":"styles_input__3N04Q","send":"styles_send__3Qn8V"};